import React, { useEffect, useState } from "react";
import { SelectInputComponent } from "../../../../../../common/components";
import { CREATED_TIME_OPTIONS } from "./filter-constants";
import CustomDateRangePicker from "./custom-date-picker";
import dayjs, { Dayjs } from "dayjs";
import { calculateDateRange } from "../../../../../../utils/filtersUtil";

interface CreatedTimeFilterProps {
  value: string;
  onChange: (value: string) => void;
  isCreatedTimeEnabled?: boolean;
  onDateRangeChange: (fromDate: Date | null, toDate: Date | null) => void;
  createdTimeError?: string;
  createdTimeStartError?: string;
  createdTimeEndError?: string;
  setCreatedTimeFromDate: (date: Dayjs | null) => void;
  setCretedTimeToDate: (date: Dayjs | null) => void;
  showDropdown?: boolean;
  fromDate?: Dayjs | null;
  toDate?: Dayjs | null;
  isProvider?: boolean;
  onFromDateError?: (error: string | null) => void;
  onToDateError?: (error: string | null) => void;
}

const CreatedTimeFilter: React.FC<CreatedTimeFilterProps> = ({
  value,
  onChange,
  isCreatedTimeEnabled,
  onDateRangeChange,
  createdTimeError,
  createdTimeStartError,
  createdTimeEndError,
  setCreatedTimeFromDate,
  setCretedTimeToDate,
  showDropdown = true,
  fromDate,
  toDate,
  isProvider = false,
  onFromDateError,
  onToDateError,
}) => {
  const [showCustomDate, setShowCustomDate] = useState(false);
  const [selectOpen, setSelectOpen] = useState(false);

  const handleOpen = () => {
    setSelectOpen(true);
  };
  const handleBlur = () => {
    setSelectOpen(false);
  };
  useEffect(() => {
    const selected = typeof value === "object" ? "" : value;
    setShowCustomDate(value.includes("Custom"));

    if (selected && selected !== "Custom") {
      const { from, to } = calculateDateRange(selected);
      onDateRangeChange(from ? from.toDate() : null, to ? to.toDate() : null);
    }
  }, [value]);

  const handleCustomRangeChange = (from: Dayjs | null, to: Dayjs | null) => {
    onDateRangeChange(from?.toDate() || null, to?.toDate() || null);
  };
  if (!isCreatedTimeEnabled) return null;

  return (
    <div className="filter-select-input-wrapper created-time-filter-main-wrapper">
      {showDropdown && (
        <SelectInputComponent
          fieldName="createdTime"
          options={CREATED_TIME_OPTIONS}
          onChange={onChange}
          value={value}
          placeholder="Select Created Time"
          isFilter={true}
          selectOpen={selectOpen}
          handleOpen={handleOpen}
          handleBlur={handleBlur}
        />
      )}
      {isProvider && createdTimeError && <div className="error-text">{createdTimeError}</div>}
      {showCustomDate && (
        <div>
          <CustomDateRangePicker
            fromDate={fromDate}
            toDate={toDate}
            onDateRangeChange={handleCustomRangeChange}
            startDateError={createdTimeStartError}
            endDateError={createdTimeEndError}
            setFromDate={setCreatedTimeFromDate}
            setToDate={setCretedTimeToDate}
            onFromDateError={onFromDateError}
            onToDateError={onToDateError}
          />
        </div>
      )}
    </div>
  );
};

export default CreatedTimeFilter;
